module.exports = __webpack_public_path__ + "img/ai-logic.8e89db86.svg";